// initial navigation state
const state = {
  navigationlist: [
    {
      title: 'Home', to: '/home', baseUrl: '/home', ifLoggedIn: true,
    },
    {
      title: 'Screens', to: '/screens', baseUrl: '/screens', ifLoggedIn: true,
    },
    {
      title: 'Groups', to: '/groups', baseUrl: '/groups', ifLoggedIn: true,
    },
    {
      title: 'Reconciliation',
      to: '/reconciliation',
      baseUrl: '/reconciliation',
      ifLoggedIn: true,
    },
    {
      title: 'Reports',
      to: '/reports',
      baseUrl: '/reports',
      ifLoggedIn: true,
    },
    {
      title: 'Key Codes',
      to: '/keys',
      baseUrl: '/keys',
      ifLoggedIn: true,
    },
    {
      title: 'Device Locations',
      to: '/devicemap',
      baseUrl: '/devicemap',
      ifLoggedIn: true,
    },
    {
      title: 'Log Out',
      to: '/login',
      ifLoggedIn: true,
    },
    { title: 'Log In', to: '/login', ifLoggedIn: false },
  ],
};

// getters
const getters = {
  getNavigationList: (state) => state.navigationlist,
};

// actions
const actions = {};

// mutations
const mutations = {
  updateNavRoutes(state, payload) {
    state.navigationlist.map((item) => {
      if (item.to != '/') {
        item.to = payload + item.baseUrl;
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
